import { gql } from '@apollo/client';

export const CLOSE_MCP_MUTATION = gql`
  mutation CloseMcp($id: Int!) {
    mcp {
      closeMcp(id: $id) {
        success
        message {
          code
          message
        }
        content {
          id
          status
        }
      }
    }
  }
`;
